import WishlistTable from "../components/Catalogue/WishlistTable";

function Wishlist() {
  return (
    <div>
      <h1 className="text-2xl py-4">Πρότυπα Παραγγελιών</h1>
      <WishlistTable />
    </div>
  );
}

export default Wishlist;
